import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutProspectList extends Layout {
    buttonProspectToLocation: Button;
    layoutheaderProspectList: LayoutHeader;
    sourceProspect: DataSource;
    tableProspectList: Table;
}
